import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from '../../common/components/Dialog';
import { Button } from 'react-bootstrap';
import RefundUnbookedAnnualForm from './RefundUnbookedAnnualForm';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import { withTranslation } from 'react-i18next';

class RefundUnbookedAnnualDialog extends Component {
	constructor(props) {
		super(props);
		this.handleCancellationReasonChange = this.handleCancellationReasonChange.bind(this);
		
		this.state = {
			cancellationReasonType: null
		};
	}

	handleCancellationReasonChange(event, cancellationReasonType) {
		this.setState({ cancellationReasonType });
	}

	dialogConfig() {
		const { t, onCancel } = this.props;

		return {
			header: t('PaymentHistory_RefundUnbookedAnnual'),
			body: this.renderBody(),
			onHide: onCancel,
			footer: this.renderFooter()
		};
	}

	renderBody() {
		const { onConfirm, cancellationReasonTypes } = this.props;
		return <RefundUnbookedAnnualForm onSubmit={onConfirm} cancellationReasonTypes={cancellationReasonTypes}
			onReasonChange={this.handleCancellationReasonChange} cancellationReasonType={this.state.cancellationReasonType} />;
	}

	renderFooter() {
		const { onCancel, t } = this.props;

		const closeBtn = <Button key='close' onClick={onCancel}>{t('Common_Close')}</Button>;
		const confirmBtn = <RemoteSubmitButton key='save' style='primary' formName='refundUnbookedAnnual'			
			label={t('PaymentHistory_RefundUnbookedAnnual')}
			confirmationTitle={t('PaymentHistory_RefundUnbookedAnnualTitle')}
			confirmationMessage={t('PaymentHistory_RefundUnbookedAnnualMessage')} />;
		return [closeBtn, confirmBtn];
	}

	render() {
		const { show, block, unblock } = this.props;
		const dialogConfig = this.dialogConfig();
		return <Dialog config={dialogConfig} show={show} block={block} unblock={unblock} />;
	}
}

RefundUnbookedAnnualDialog.propTypes = {
	show: PropTypes.bool,
	block: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	unblock: PropTypes.oneOfType([
		PropTypes.instanceOf(RegExp),
		PropTypes.string,
		PropTypes.array,
		PropTypes.func
	]),
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired
};

export default withTranslation()(RefundUnbookedAnnualDialog);